import React, { useEffect, useState } from "react";
import { getFiles } from "API/swesum";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import Paper from "Components/UI/Paper";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ClientPaymentForm from "Components/ClientPayment/ClientBankFileForm";
import { useClients } from "Context/Clients";
import { useClientPayments } from "Context/ClientPayments";
import { usePopupNotificationContext } from "Context/NotificationPopup";

const initialState = {
  Amount: null,
  Status: "",
  ID: null,
  File: "",
};

export function CreateClientPayment() {
  const [formData, setFormData] = useState(initialState);
  const [files, setFiles] = useState([]);
  const { clients, fetchClients, hasFetchedAll } = useClients();
  const { createClientPayment } = useClientPayments();
  const { openError } = usePopupNotificationContext();

  const fetchFiles = async () => {
    const tmpFiles = await getFiles();
    setFiles(tmpFiles);
  };
  useEffect(() => {
    fetchFiles();
    if (!hasFetchedAll) {
      fetchClients();
    }
  }, []);

  const createNewClient = async () => {
    const res = await createClientPayment(formData);
    if (res.status === 201) {
      navigate(`/clientpayments/${res.data.Id}`);
    } else {
      openError("Ett fel uppstod när fakturan skapades.");
    }
  };

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  if (!files) {
    return null;
  }

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 5 }}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography sx={{ marginBottom: "2rem" }} variant="h5">
              Skapa Klientutbetalning
            </Typography>
            <ClientPaymentForm
              formData={formData}
              clients={clients}
              files={files}
              handleInputChange={handleInputChange}
            />
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button onClick={() => navigate(-1)}>Stäng</Button>
              <Button
                sx={{ ml: 3 }}
                onClick={() => createNewClient()}
                variant="contained"
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>
      </Box>
    </>
  );
}
